import { LuMenu, LuX } from "react-icons/lu";
import { useAppSelector } from "../../data/store/hooks";
import { selectUser } from "../../data/store/selectors/userSelector";
import { Search } from "../search/search";
import { useState } from "react";
import SidebarMobile from "../sidebar/sidebar-mobile";

interface NavbarProps {
  onSearch: (query: string) => void;
}

const LuXIcon = LuX as React.ElementType;
const LuMenuIcon = LuMenu as React.ElementType;

export const Navbar = ({ onSearch }: NavbarProps) => {
  const user = useAppSelector(selectUser);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMenuIcon = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  return (
    <div className="relative border-b md:border-none">
      <div className="flex px-2 py-4 md:px-4 items-center justify-between md:space-x-4">
        <div className="hidden md:block">
          <Search placeholder="Search" onSearch={onSearch} />
        </div>

        <div className="flex space-x-2 items-center">
          <div
            onClick={() => toggleMenuIcon()}
            className="block md:hidden cursor-pointer"
          >
            {mobileMenuOpen ? <LuXIcon size={20} /> : <LuMenuIcon size={20} />}
          </div>

          <div className="font-semibold md:hidden">Admin Dashboard</div>
        </div>
        <div className="flex items-center space-x-2 md:space-x-2">
          <div className="flex flex-col">
            <div className="text-sm font-semibold flex items-center space-x-1 flex-nowrap">
              <span>{user?.lastName}</span> <span>{user?.firstName}</span>
            </div>
            <div className="text-xs">Admin</div>
          </div>

          {user?.isAdmin &&
          user?.image === "https://i.ibb.co/4pDNDk1/avatar.png" ? (
            <div className="w-10 h-10 rounded-full bg-rose-500 flex items-center justify-center text-white font-bold text-lg">
              A
            </div>
          ) : (
            <img
              className="rounded-full w-10 h-10 object-cover"
              src={user?.image}
              alt="avatar_img"
            />
          )}
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="w-full h-full absolute z-50 -bottom-16">
          <SidebarMobile setMobileMenuOpen={setMobileMenuOpen} />
        </div>
      )}
    </div>
  );
};
